import React from 'react';

import { TextInput, Button } from '@upgrade/react-components';
import { joinPaths } from '@upgrade/ui-utils/utils/url';

import { CREDIT_HEALTH_INSIGHTS_PATH } from '../../constants/path-constants';
import { SearchField } from './styles';

export default props => (
  <SearchField action={joinPaths(CREDIT_HEALTH_INSIGHTS_PATH, '/search/')} {...props}>
    <TextInput ariaLabel="Search articles" name="query" placeholder="Search articles" floating={false} />
    <Button buttonProps={{ type: 'submit' }}>Search</Button>
  </SearchField>
);
